import { styled } from '@cp/ds/src/theme';
import { Box } from '@cp/ds/src/components/box';
import { name } from './const';

export const PinnedMessage = styled(Box, { name })(({ theme }) => ({
  backgroundColor: theme.palette['gray middle'],
  padding: theme.spacing(1),
  borderRadius: theme.borderRadius.normal,
}));
